<div class="admin-form mt-2">
  <div class="page-title-container">
    <div class="page-title">
      <em class="page-title-icon icon-store"></em>
      <h4>Store</h4>
    </div>
    <div>
      <div class="form-group text-nowrap d-flex">
        <div class="mr-2">
          <app-store-create-button></app-store-create-button>
        </div>
        <app-store-import-order-schedule></app-store-import-order-schedule>
      </div>
    </div>
  </div>

  <app-tab [routeLinkTabs]="listRoute" [notRefresh]="true"></app-tab>

  <router-outlet></router-outlet>
</div>
